import { logError } from "../newRelicLogger";
import getWindow from "../window";
import {
  mapOffersToTemplate,
  ratingsTemplate,
  reviewsTemplate,
} from "./schemaOrgTemplates";
import { dataMapper } from "./dataMapper";

export const createAndInsertInToPage = async ({ products, ratings }) => {
  try {
    const data = dataMapper(products, ratings);
    const splitStructuredDataElement = getWindow().document.getElementById(
      "split-structured-data"
    );

    await insertAdditionalData(splitStructuredDataElement, data);
  } catch (error) {
    logError(error, {
      action: "RenderingStructuredDataToPage",
      message: "Error while generating/adding structured data",
    });
  }
};

const insertAdditionalData = async (element, data) => {
  const splitStructuredData = getStructuredData(element);

  if (dataHasGraphStructure(splitStructuredData)) {
    addProductDataToGraphStructure(splitStructuredData, data);
    insertStructuredDataIntoPage(element, splitStructuredData);
  } else {
    splitStructuredData.offers = mapOffersToTemplate(data.offers);

    if (data.ratings) {
      splitStructuredData.aggregateRating = ratingsTemplate(data.ratings);
    }

    if (data.reviews && data.reviews.length > 0) {
      splitStructuredData.review = reviewsTemplate(data.reviews);
    }

    insertStructuredDataIntoPage(element, splitStructuredData);
  }
};

const addProductDataToGraphStructure = (splitStructuredData, data) => {
  const productItem = splitStructuredData["@graph"].find(
    (graphItem) => graphItem["@type"] === "Product"
  );

  if (productItem) {
    productItem.offers = mapOffersToTemplate(data.offers);

    if (data.ratings) {
      productItem.aggregateRating = ratingsTemplate(data.ratings);
    }
  }
};

const dataHasGraphStructure = (splitStructuredData) => {
  return Array.isArray(splitStructuredData["@graph"]);
};

const getStructuredData = (element) => {
  try {
    return JSON.parse(element.textContent);
  } catch (error) {
    logError(error, {
      action: "getStructuredData",
      message: "Error while parsing structured data from page to JSON",
    });
    return {};
  }
};

const insertStructuredDataIntoPage = (element, splitStructuredData) => {
  element.textContent = JSON.stringify(splitStructuredData);
};
